import { render, staticRenderFns } from "./ReviewStarted.vue?vue&type=template&id=887cce6c&scoped=true&"
import script from "./ReviewStarted.vue?vue&type=script&lang=js&"
export * from "./ReviewStarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887cce6c",
  null
  
)

export default component.exports